var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.373,
    height: 117.006,
    viewBox: "0 0 155.373 117.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(0 13.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M433.226,415.378c5.325-9.367,15.481-16.559,26.233-15.866A49.641,49.641,0,0,0,446.4,430.995c-.177,4.515.1,9.556-2.9,12.937a11.1,11.1,0,0,1-7.52,3.336,32.958,32.958,0,0,1-8.372-.8l-.671.206C426.683,435.905,427.9,424.745,433.226,415.378Z",
    transform: "translate(-377.493 -355.891)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M459.449,398.7a42.432,42.432,0,0,0-18.892,18.016,18.276,18.276,0,0,0-2,5.364,10.48,10.48,0,0,0,.545,5.488,21.692,21.692,0,0,1,1.566,5.011,6.417,6.417,0,0,1-1.717,4.959,16.671,16.671,0,0,1-5.523,3.675c-2.228,1.055-4.559,2.117-6.137,4.086-.191.239-.55-.072-.359-.31,2.746-3.427,7.445-4.072,10.7-6.833a6.5,6.5,0,0,0,2.59-5.1,16.83,16.83,0,0,0-1.493-5.118A11.182,11.182,0,0,1,438,422.6a16.892,16.892,0,0,1,1.786-5.421,41.162,41.162,0,0,1,7.57-10.4,43.182,43.182,0,0,1,11.94-8.519c.275-.132.427.318.154.449Z",
    transform: "translate(-377.467 -354.857)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M504.733,453.758a6.366,6.366,0,0,1-1.921-8.016c.139-.272.568-.069.429.2a5.9,5.9,0,0,0,1.8,7.453C505.291,453.578,504.979,453.936,504.733,453.758Z",
    transform: "translate(-440.424 -394.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M498.146,549.9a12.27,12.27,0,0,0,7.768-4.428c.192-.238.551.073.359.31a12.763,12.763,0,0,1-8.093,4.591c-.3.043-.336-.431-.035-.474Z",
    transform: "translate(-436.921 -477.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M572.912,432.392a3.6,3.6,0,0,0,3.221,1.148c.3-.047.335.427.035.474a4.038,4.038,0,0,1-3.566-1.262.245.245,0,0,1-.025-.335A.239.239,0,0,1,572.912,432.392Z",
    transform: "translate(-499.324 -383.391)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M478.728,550.425c-.188.035-.376.07-.566.108a47.438,47.438,0,0,0-7.419,2.051c-.188.065-.377.134-.562.2a50.029,50.029,0,0,0-15.734,9.575,48.576,48.576,0,0,0-5.1,5.34c-2.155,2.633-4.283,5.66-7.1,7.377a8.348,8.348,0,0,1-.907.492l-16.226-6.73c-.029-.034-.06-.064-.089-.1l-.66-.239c.074-.1.152-.21.226-.314.042-.06.089-.119.131-.18.029-.04.059-.08.083-.117l.028-.036c.024-.038.051-.07.074-.1q.657-.893,1.328-1.779s0,0,.007-.006a71.43,71.43,0,0,1,11.6-12.275c.131-.106.263-.216.4-.319a46.361,46.361,0,0,1,6.266-4.239,41,41,0,0,1,3.717-1.838,34.083,34.083,0,0,1,10.325-2.633c7.094-.659,14.32.959,19.761,5.415C478.455,550.194,478.591,550.307,478.728,550.425Z",
    transform: "translate(-375.369 -477.255)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M479.763,575.229a42.429,42.429,0,0,0-25.931,3.01A18.273,18.273,0,0,0,449,581.318a10.48,10.48,0,0,0-2.869,4.71,21.693,21.693,0,0,1-1.767,4.944,6.417,6.417,0,0,1-4.357,2.925,16.671,16.671,0,0,1-6.623-.391c-2.414-.5-4.914-1.055-7.36-.432-.3.076-.4-.389-.1-.464,4.256-1.083,8.4,1.232,12.661.989a6.5,6.5,0,0,0,5.138-2.511,16.826,16.826,0,0,0,1.889-4.985,11.182,11.182,0,0,1,2.634-4.71,16.891,16.891,0,0,1,4.69-3.253,41.166,41.166,0,0,1,12.307-3.749,43.181,43.181,0,0,1,14.662.387C480.209,574.837,480.06,575.288,479.763,575.229Z",
    transform: "translate(-376.526 -501.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M611.834,553.166a6.366,6.366,0,0,1,3.292-7.557c.275-.134.5.287.22.421a5.9,5.9,0,0,0-3.048,7.036c.09.292-.375.391-.464.1Z",
    transform: "translate(-531.986 -478.142)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M549.581,642.39a12.27,12.27,0,0,0,8.869,1.142c.3-.074.4.39.1.464a12.762,12.762,0,0,1-9.226-1.207C549.055,642.641,549.314,642.243,549.581,642.39Z",
    transform: "translate(-479.819 -559.109)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M694,575.116a3.6,3.6,0,0,0,1.88,2.856c.27.144.011.542-.257.4a4.038,4.038,0,0,1-2.087-3.155.246.246,0,0,1,.182-.282A.239.239,0,0,1,694,575.116Z",
    transform: "translate(-600.566 -502.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M196.832,504.034c-2.272-10.987-5.113-14.65-5.113-14.65l-1.085-.841-1.3-1.014.006-.13-.31-.105-.073-.056-.119-.092-.019.021-.04.042-5.9-2.007-7.492-2.545-3.469-4.509a6,6,0,0,0-4.8-2.341l-11.079.082a6,6,0,0,0-4.036,1.6l-7.282,6.755-11.347,5.419-.019-.019-.119.085-1.753.838.072.377-1.085.783s-2.84,3.409-5.113,13.632c-.578,2.6-.863,8.182-.965,15.058a2.625,2.625,0,0,0,2.624,2.664h68.17a2.625,2.625,0,0,0,2.624-2.661C197.7,512.936,197.416,506.855,196.832,504.034Z",
    transform: "translate(-124.382 -419.761)",
    fill: "#c2b59c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M570.008,191.732a8.891,8.891,0,0,0,0,17.781h66.257a8.891,8.891,0,0,0,0-17.781Z",
    transform: "translate(-489.782 -182.087)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M579.224,202.747a7.091,7.091,0,0,0,0,14.183h66.257a7.091,7.091,0,0,0,0-14.183Z",
    transform: "translate(-498.998 -191.303)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "ab6171fa-7d69-4734-b81c-8dff60f9761b",
    cx: 14.515,
    cy: 14.515,
    r: 14.515,
    transform: "translate(24.413 22.853)",
    fill: "#e3dac8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M339.022,443.868l-.185-.411c.024,0,.047,0,.071,0Z",
    transform: "translate(-303.807 -392.696)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M242.236,241.4a4.04,4.04,0,0,1,2.531-1.094c.939.03,1.89.878,1.7,1.8a14.916,14.916,0,0,1,17.95-6.731c2.333.823,4.62,2.47,5.156,4.884a4.4,4.4,0,0,0,.554,1.8,2.058,2.058,0,0,0,2.191.555l.023-.007a.686.686,0,0,1,.829.968l-.66,1.231a5.29,5.29,0,0,0,2.52-.054.685.685,0,0,1,.728,1.066,11.944,11.944,0,0,1-9.523,4.9c-2.637-.016-5.3-.925-7.868-.319a6.835,6.835,0,0,0-4.6,9.594,2.229,2.229,0,0,0-3.119.187,4.278,4.278,0,0,0-.934,3.273,15.188,15.188,0,0,0,1.559,5.1,15.241,15.241,0,0,1-9.035-27.149Z",
    transform: "translate(-218.227 -217.886)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M87.464,495.253l4.071,22.15,2.443.213Z",
    transform: "translate(-73.177 -414.297)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M328.642,485.026l-4.071,23.8-2.443.229Z",
    transform: "translate(-269.512 -405.74)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M256.68,160.719a2.5,2.5,0,0,1-3.348-1.468,2.54,2.54,0,0,1,1.331-3.465,2.668,2.668,0,0,1,2.016,4.933ZM254.1,152.96l-1.073.448a1.157,1.157,0,0,1-1.47-.539l-.053-.1a9.384,9.384,0,0,1-.391-7.516c.83-2.605,1.174-4.437.481-6.1-.8-1.919-2.513-2.52-4.695-1.649a3.989,3.989,0,0,0-1.782,1.009,1.529,1.529,0,0,1-1.107.45,1.478,1.478,0,0,1-1.058-.464,1.51,1.51,0,0,1-.01-2.06,11.726,11.726,0,0,1,3.966-2.723c4.689-1.958,7.049.933,8.129,3.519,1.056,2.53.462,4.878-.493,7.918a7.86,7.86,0,0,0,.155,6.259,1.152,1.152,0,0,1-.6,1.55Z",
    transform: "translate(-225.99 -146.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M636,268.869H622.816a.318.318,0,0,1,0-.635H636a.318.318,0,0,1,0,.635Z",
    transform: "translate(-541.137 -246.094)",
    fill: "#3a7735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M738.379,269.517H725.2a.318.318,0,1,1,0-.635h13.182a.317.317,0,1,1,0,.635Z",
    transform: "translate(-626.795 -246.636)",
    fill: "#3a7735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M840.761,270.165H827.579a.318.318,0,0,1,0-.635h13.182a.318.318,0,0,1,0,.635Z",
    transform: "translate(-712.454 -247.178)",
    fill: "#3a7735"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M943.139,270.813H929.957a.318.318,0,0,1,0-.635h13.182a.318.318,0,1,1,0,.635Z",
    transform: "translate(-798.11 -247.72)",
    fill: "#3a7735"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "*",
    transform: "translate(85.392 8.886)",
    fill: "#3a7735",
    fontSize: 18,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.816,
    y: 18
  }, "*")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "*",
    transform: "translate(102.47 8.886)",
    fill: "#3a7735",
    fontSize: 18,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.816,
    y: 18
  }, "*")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": "*",
    transform: "translate(118.544 8.886)",
    fill: "#3a7735",
    fontSize: 18,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.816,
    y: 18
  }, "*")), /*#__PURE__*/React.createElement("text", {
    id: "_4",
    "data-name": "*",
    transform: "translate(135.622 8.886)",
    fill: "#3a7735",
    fontSize: 18,
    fontFamily: "Alef-Bold, Alef",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -1.816,
    y: 18
  }, "*")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPass);
export default __webpack_public_path__ + "static/media/forgotPass.83fc685a520c8645b29a5d2bc6158a38.svg";
export { ForwardRef as ReactComponent };